module.exports = __webpack_public_path__ + "media/images/favicon-d33c9db8c4f91f91c07b2e54ac89ca6b.ico";